import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import vuetify from './plugins/vuetify'
import { auth } from './firebase'
import { firestorePlugin } from 'vuefire'

Vue.use(firestorePlugin)

const requireComponent = require.context(
  './components',
  false,
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'))
  )

  Vue.component(componentName, componentConfig.default || componentConfig)
})

Vue.config.productionTip = false

let app
auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      i18n,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})
